import { FactoryTypes, FieldID } from "../../../models";

export const iphoneToAndroidSetupWithPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.tipUseGoogleAccountToSetupPhone,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnOnNewPhoneAndFollowSetupSteps
              .text,
            image:
              FieldID.guideContainer.steps.turnOnNewPhoneAndFollowSetupSteps
                .image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.tapFromiPhoneDevice.text,
            image: FieldID.guideContainer.steps.tapFromiPhoneDevice.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.copyYourDataScreenInstructions
              .text,
            image:
              FieldID.guideContainer.steps.copyYourDataScreenInstructions.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.turnOffiMessage.text,
            image: FieldID.guideContainer.steps.turnOffiMessage.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.signInToGoogleAccount.text,
            image: FieldID.guideContainer.steps.signInToGoogleAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.backupToGoogleDriveCompleted
              .text,
            image:
              FieldID.guideContainer.steps.backupToGoogleDriveCompleted.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const iphoneToAndroidSetupLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.chargeBothPhonesAndBringAdapter,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.confirmYourAccount.text,
            image: FieldID.guideContainer.steps.confirmYourAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .androidSetupCopyAppsandDataFromIphone.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.androidSetupCopyAppsandDataFromIphone
                .images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .androidSetupGoogleServicesTermsAccept.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.androidSetupGoogleServicesTermsAccept
                .images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .androidSetupFollowOnscreenInstructions.text,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const telusKoodoIphoneToAndroidSetupLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.iphoneToSamsungLostData,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText: FieldID.guideContainer.decisionStep.doYouKnowGooglePassword,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.TIPBOX,
          fieldMapping: {
            text: FieldID.guideContainer.tipBox.useGoogleAccountNewPhone,
            icon: FieldID.guideContainer.tipBox.icon,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.findGmailAddress.text,
            image: FieldID.guideContainer.steps.findGmailAddress.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.confirmYourAccount.text,
            image: FieldID.guideContainer.steps.confirmYourAccount.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.checkEmailUsernameList.text,
            image: FieldID.guideContainer.steps.checkEmailUsernameList.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.resetGmailPassword.text,
            image: FieldID.guideContainer.steps.resetGmailPassword.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.answerSecurityQuestions.text,
            image: FieldID.guideContainer.steps.answerSecurityQuestions.image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.TIPBOX,
          fieldMapping: {
            text: FieldID.guideContainer.tipBox.makeSureConnectedThreeSteps,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.samsungCopyAppsAndDataFromIphone
              .text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.samsungCopyAppsAndDataFromIphone
                .images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.androidAcceptGoogleTerms.text,
          },
        },
        {
          type: FactoryTypes.IMAGE_CAROUSEL,
          fieldMapping: {
            images:
              FieldID.guideContainer.steps.androidAcceptGoogleTerms.images,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.followInstructionsCompleteSetup
              .text,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];
